import React from 'react';
import classNames from 'classnames';
import { Gallery } from 'lib/components/Gallery';

export function GalleryBlock({ blockProps }) {
	const { entityData, onRemove } = blockProps;
	const { name, base, images } = entityData;

	return (
		<Gallery {...entityData} />
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/component/GalleryBlock.jsx